const mobile = { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的电话号码' }
const weight = { pattern: /^[0-9]{1,4}([.][0-9]{1,3})?$/, message: '最大输入9999.999' }
const weight4 = { pattern: /^[0-9]{1,5}([.][0-9]{1,4})?$/, message: '最大输入99999.9999' }
const storagePrice = { pattern: /^[0-9]{1,8}([.][0-9]{1,2})?$/, message: '最大输入99999999.99' }
const price = { pattern: /^[0-9]{1,5}([.][0-9]{1,2})?$/, message: '最大输入99999.99' }
const vhcVinNo = { pattern: /^[A-HJ-NPR-Z\d]{17}$/, message: '请输入正确的车架号' }
const vhcNo = { pattern: /^/, message: '请输入正确的车牌号' }
const centerRadius = { pattern: /^([1-9]\d{0,2}|[1-4]\d{3}|5000)$/, message: '最大输入5000' }
let idCardValidity = (rule, code, callback) => {
  var city = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江 ', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北 ', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏 ', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外 ' }
  var tip = ''
  var pass = true

  if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
    tip = '请输入正确的身份证号'
    pass = false
  } else if (!city[code.substr(0, 2)]) {
    tip = '请输入正确的身份证号'
    pass = false
  } else {
    // 18位身份证需要验证最后一位校验位
    if (code.length === 18) {
      code = code.split('')
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      // 校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      var sum = 0
      var ai = 0
      var wi = 0
      for (var i = 0; i < 17; i++) {
        ai = code[i]
        wi = factor[i]
        sum += ai * wi
      }
      var last = parity[sum % 11]
      if (parity[sum % 11] != code[17]) {
        tip = '请输入正确的身份证号'
        pass = false
      }
    }
  }
  if (!pass) {
    callback(new Error(tip))
  } else {
    callback()
  }
  // if (!pass) alert(tip)
  // return pass
}
let isVhcClassify = (rule, code, callback) => {
  var pass = true
  let tip = '请选择车辆所属'
  if (Array.isArray(code)) {
    code.forEach(item => {
      if (item == null) {
        pass = false
      }
    })
  }
  if (!pass) {
    callback(new Error(tip))
  } else {
    callback()
  }
}
export default {
  mobile,
  weight,
  weight4,
  storagePrice,
  price,
  vhcNo,
  vhcVinNo,
  centerRadius,
  isVhcClassify,
  idCardValidity
}
